<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormContractItem
      :ContractItem="editContractItem"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormContractItem from '../components/FormContractItem.vue';

export default {
  components: {
    FormContractItem,
  },
  name: 'EditContractItem',
  module: 'Contracts',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing ContractItem. Default to {}.
      */
      editContractItem: {},
      /**
       * Query Id for ContractItem
       */
      contractItemId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('contractItems', ['contractItems', 'contractItem']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.contractItemId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_contractItem(this.contractItemId);
      this.editContractItem = this.contractItem;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('contractItems', ['LOAD_contractItem', 'CREATE_contractItem', 'UPDATE_contractItem']),
    /** Method used to save the item
     */
    async save(contractItem) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_contractItem(contractItem);
      } else {
        await this.UPDATE_contractItem(contractItem);
      }
      this.isSaving = false;
      this.$router.push({ name: 'contract-item-ListContractItem' });
    },
  },
};
</script>

<docs>
# EditContractItem example

'''js
<EditContractItem :ContractItem="ContractItem" />
'''
</docs>
